<script setup>
import paymentWait from "@/assets/images/payment-wait.svg";
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";
import Container from "@/components/atoms/container";
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider"

export default {
  name: "OrderAttente",
  components: {
    LazyImage,
    Container,
    Icon,
    Divider
  },
  props: {
    email: {
      type: String,
      required: false,
      default: null
    },
    magasin: {
      type: String,
      required: false,
      default: null
    },
    telephone: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
    class="u-bgcolor-white u-text-center u-pb-xxlg"
  >
    <Container>
      <div class="u-flex u-flex-justify-center u-pt-xlg">
        <LazyImage
          :src="paymentWait"
          width="125"
          height="80"
        />
      </div>
      <h1 class="u-font-24 u-color-primary u-mt-sm">
        Nous procédons à la vérification de vos informations bancaires
      </h1>
      <p class="u-font-15 u-pb-md u-mt-sm u-mb-xlg">
        Vous devriez recevoir un e-mail de confirmation de commande à l’adresse {{ email }}
      </p>

      <div class="u-flex-column u-radius-md u-border-grey-7 u-pt-sm u-pb-sm u-pl-sm u-pr-sm u-mt-md u-ml-xs u-mr-xs">
        <div class="u-flex-column u-flex-justify-between u-flex-align-start u-mb-sm u-text-left">
          <div class="u-font-17 u-flex u-flex-align-center u-mt-xs u-pb-xs">
            <Icon
              name="location"
              size="sm"
            /> Cora {{ magasin }}
          </div>
        </div>
        <Divider dotted />
        <div class="u-text-left">
          <p class="u-font-700 u-mt-md u-font-17">
            Si vous ne recevez pas cet email dans les minutes qui suivent
          </p>
          <p class="u-mt-md u-font-17">
            1. Veillez à bien vérifier votre dossier « Spam » ou « Courrier indésirable » de votre messagerie
          </p>
          <p class="u-mt-md u-mb-sm u-font-17">
            2. Contactez votre service coradrive au {{ telephone }}
          </p>
        </div>
      </div>
    </Container>
  </div>
</template>
